import './KeyButton.css'

interface KeyButtonProps {
    text: string
    fontSize?: number
    fontWeight?: number
    scale?: number
    translateX?: string
    translateY?: string
    containerStyles?: React.CSSProperties
    textStyles?: React.CSSProperties
}

export const KeyButton = ({ text, fontSize = 1, fontWeight = 600, scale = 1, translateX = "-5%", translateY = "-5%", containerStyles, textStyles }: KeyButtonProps) => {
    return (
        <div className="key-button"
            style={containerStyles}
        >
            <p className="key-button-text"
                style={{
                    fontSize: `${fontSize}rem`,
                    fontWeight: fontWeight,
                    transform: `scale(${scale}) translateX(${translateX}) translateY(${translateY})`,
                    ...textStyles
                }}
            >
                {text}
            </p>
        </div>
    )
}